import { useNavigate } from 'react-router-dom'
import { UiButton } from './ui'

export function SetupBranchPrompt({ title = 'Create your first branch' }) {
  const navigate = useNavigate()

  return (
    <div className="rounded-2xl border border-amber-500/20 bg-amber-500/10 p-5 text-center space-y-3">
      <p className="text-white font-medium">{title}</p>
      <p className="text-sm text-zinc-400">
        Sales, stock, and the dashboard need at least one branch. Set up your main location to continue.
      </p>
      <UiButton variant="primary" onClick={() => navigate('/onboarding/branch')}>
        Set up first branch
      </UiButton>
    </div>
  )
}

export default SetupBranchPrompt
